import type { ReactNode } from 'react';
import { useAuth } from '../auth/useAuth.js';
import { useShopLiveData } from '../../hooks/useShopLiveData.js';
import { getAccessToken } from '../../lib/amplify.js';
import { LiveDataContext } from './live-context.js';

export interface LiveDataProviderProps {
  readonly children: ReactNode;
}

export function LiveDataProvider({ children }: LiveDataProviderProps): JSX.Element {
  const { shopId } = useAuth();
  const baseUrl =
    import.meta.env.VITE_WS_URL ??
    (typeof window !== 'undefined' ? window.location.origin.replace(/^http/, 'ws') : '');

  const { connection } = useShopLiveData({
    shopId,
    baseUrl,
    getToken: () => getAccessToken(),
  });

  return (
    <LiveDataContext.Provider value={{ connection }}>{children}</LiveDataContext.Provider>
  );
}
